import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import { Icon } from 'react-icons-kit'
import { ic_add_box } from 'react-icons-kit/md/ic_add_box'
import { ic_search } from 'react-icons-kit/md/ic_search'
import { ic_delete } from 'react-icons-kit/md/ic_delete'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import Dialog from '@material-ui/core/Dialog';
import { MDBContainer, MDBIframe } from "mdbreact";
import NavBar from '../components/NavBar'
import FrTable from '../components/FrTable'
import FrTextInput from '../components/FrTextInput'
import FrSelect from '../components/FrSelect'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import FrDatePicker from '../components/FrDatePicker'
import FooterDelphus from '../components/FooterDelphus'


import api from '../services/api'
import { paramsToObject, formToObject, populateForm, objectToQueryString } from '../utils/functions'

import './styles/DefaultMainScreen.css';
import './styles/Manut.css';

const swal = withReactContent(Swal)

function DemonstrativoAnual(props) {
  const [data, setData] = useState([])
  const [filter, setFilter] = useState({})
  const [filtered, setFiltered] = useState(false)
  const [enableAdd, setenableAdd] = useState('N')
  const [enableEdit, setenableEdit] = useState('N')
  const [enableDel, setenableDel] = useState('N')
  const [arquivoTermo, setArquivoTermo] = useState(0)
  const [showModalArquivo, setShowModalArquivo] = useState(0)
  const [selected, setSelected] = useState([])

  const [comboEstado, setComboEstado] = useState([{ value: '', display: '' }])

  const columns = [
    { id: 'fk_cto', numeric: false, label: 'Contrato', align: 'left', minWidth: 70 },
    { id: 'nomecli', numeric: false, label: 'Cliente', align: 'left', minWidth: 450 },
    // { id: 'estado', numeric: false, label: 'Estado', align: 'left', minWidth: 200 },

  ]

  useEffect(() => {
    const fetchData = async () => {
      swal.fire({
        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })

      setComboEstado(await api.getComboData('estados'))
      setenableAdd(await api.getAcessos('Demonstrativo', 'Inclusao'))
      setenableEdit(await api.getAcessos('Demonstrativo', 'Alteracao'))
      setenableDel(await api.getAcessos('Demonstrativo', 'Exclusao'))


      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)
      setFilter(query)
      populateForm(document.getElementById('searchForm'), query)

      swal.close()
      if (query.buscar === 'true') {
        let event = new Event('build');
        getData(event)

        
      }
    }

    fetchData()
  }, [])

  function getData(e) {
    e.preventDefault()
    var formData = new FormData(document.getElementById('searchForm'))
    var queryObject = formToObject(formData)
    queryObject.buscar = true
    setFiltered(true)
    if (queryObject.dataini && queryObject.datafim){
      
      window.history.replaceState({ filtered: true }, 'filter', "/salute/demonstrativos_anuais?" + objectToQueryString(queryObject));
      swal.fire({
        html: <FrLoading text="Buscando dados..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      api.get('/lancamentos/demonstrativos', { params: queryObject }).then(r => {
        setData(r.data)
        swal.close()
      })

    } else {
      swal.fire('Período inválido!', 'Selecione um período.', 'error')
    }
  }

  function geraDemonstrativo() {
    var formData = new FormData(document.getElementById('searchForm'))
    var queryObject = formToObject(formData)
    queryObject.buscar = true
    setFiltered(true)
    setArquivoTermo(api.backendUrl + '/api/lancamentos/demonstrativo_relatorio?selected=' + selected + '&dataini='+queryObject.dataini+'&datafim='+queryObject.datafim )
    // api.get('/lancamentos/demonstrativo_relatorio', { params: queryObject }).then(r => {
      // console.log(r.data)
      // let data = URL.createObjectURL(r.data)
      // setArquivoTermo(r.data)
      setShowModalArquivo(true)
      swal.close()
    // })
  }


  function clearForm(e) {
    e.preventDefault();
    window.history.replaceState({ filtered: false }, 'filter', '/salute/demonstrativos');
    document.getElementById('searchForm').reset()
    setFilter({})
  }

  const handleChange = (e) => {
    const auxValues = { ...filter };
    auxValues[e.target.name] = e.target.value;
    setFilter(auxValues);
  };

  function limpaModal() {
    setShowModalArquivo(false)
  }

  return (
    <div className="Manut">
      <NavBar />
      <div>
        <Dialog aria-labelledby="simple-dialog-title" open={showModalArquivo} fullWidth={true} maxWidth={'lg'}>
          <div className="FrModalFooter">
            <div className="FrModalButtonsDiv">
              <MDBContainer className="text-center">
                <MDBIframe src={arquivoTermo} />
              </MDBContainer>
              <button onClick={limpaModal}> Sair </button>
            </div>
          </div>
        </Dialog>
      </div>
      <div className="ManutContent">
        <div className="defaultHeader">
          <h3>Cidades</h3>
          <UserOptions temaEscuro={props.temaEscuro} setTemaEscuro={props.setTemaEscuro} />
        </div>
        <br />
        <div className="filtersDiv">
          <form id="searchForm" onSubmit={getData}>
            <div>
              <FrTextInput
                value={filter.fk_cto || ''}
                style={{ width: 330 }}
                name="fk_cto"
                id="fk_cto"
                color="#389492"
                label="Nº Contrato"
                variant="outlined"
                size="small"
                onChange={handleChange}
              />

              <FrDatePicker
                value={(filter.dataini || '').split('T')[0]}
                name="dataini"
                id="dataini"
                color="#49573B"
                label="Período"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
              />

              <label style={{ paddingRight: '7px', paddingTop: '7px' }}>a</label>

              <FrDatePicker
                value={(filter.datafim || '').split('T')[0]}
                name="datafim"
                id="datafim"
                color="#49573B"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
              />


            </div>
            <div>
              <button onClick={getData}>
                <Icon icon={ic_search} size={18} />
                Pesquisar
              </button>
              <button onClick={clearForm}>
                <Icon icon={ic_delete} size={18} />
                Limpar
              </button>
              <button onClick={geraDemonstrativo}>
                <Icon icon={ic_delete} size={18} />
                Gerar demonstrativos
              </button>
            </div>
          </form>
        </div>
        <br />
        <div className="tableDiv">
          <FrTable 
            regName="cidades" 
            columns={columns} 
            searched={filtered} 
            codeName="fk_cto" 
            page={'Cidades'} 
            data={data} 
            enableEdit={enableEdit} 
            enableDel={enableDel} 
            selected={selected}
            setSelected={setSelected}
            mostraCheck='S'
          />
        </div>
        <FooterDelphus />
      </div>
    </div>
  );
}

export default DemonstrativoAnual;
